
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30724',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30724",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55239",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8283",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11740",
  "I18n": "static-7.1664",
  "quartz": "static-1.7391",
  "quartz-config": "static-1.1169",
  "quartz-core": "static-1.6610",
  "react-dlb": "static-1.85",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.874",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55226",
  "feedback-utils": "static-1.55230",
  "forms-embed-utils-lib": "static-1.4721",
  "forms-utils-lib": "static-1.13033",
  "foundations-assets": "static-1.5140",
  "foundations-components": "static-1.8410",
  "foundations-theming": "static-1.4722",
  "hub-http": "static-1.6470",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12047",
  "icons": "static-2.675",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4101",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16968",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5524",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.496",
  "tinymce-plugins": "static-1.58137",
  "transmute": "static-2.85",
  "ui-images": "static-2.1232",
  "UIComponents": "static-3.8686",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3587",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3668",
  "quartz-webpack": "static-1.3615",
  "foundations-theming-specialty": "static-1.2438",
  "property-description-translator": "static-1.4097",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3394",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4573",
  "jasmine-runner": "static-1.6706",
  "opentelemetry-fe-types": "static-1.27",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4832",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.402",
  "quartz-auth": "static-1.1066",
  "quartz-head": "static-1.1056",
  "quartz-i18n": "static-1.1066",
  "quartz-routing": "static-1.821",
  "quartz-test": "static-1.1066",
  "quartz-tracking": "static-1.770",
  "trellis-components": "static-1.2528",
  "ui-fonts": "static-1.1002",
  "usage-tracker-container": "static-1.7603",
  "usage-tracker-core": "static-1.7463",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.162",
  "conversations-skeleton-state": "static-1.7505",
  "reference-resolvers": "static-1.8436",
  "sanitize-text": "static-1.8407",
  "PatternValidationJS": "static-1.3154",
  "ReduxMessenger": "static-2.10624",
  "sanitize": "static-1.4732",
  "outpost": "static-1.4417",
  "rpc-client-utils": "static-1.4919",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4679",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9683",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2509",
  "bend-plugin-foundations-theming": "static-1.3205",
  "foundations-theming-base": "static-1.3707",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.262",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9620",
  "atom": "static-1.5342",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8142",
  "ContentUtils": "static-1.69063",
  "data-token-picker": "static-1.16827",
  "file-manager-components": "static-1.24389",
  "FileManagerCore": "static-1.39888",
  "FileManagerLib": "static-1.40029",
  "frontend-preferences-client": "static-1.8183",
  "hub-http-contrib": "static-1.3294",
  "interframe": "static-3.5012",
  "layout-dnd-components": "static-1.12902",
  "layout-dnd-utils": "static-1.11877",
  "property-translator": "static-1.5654",
  "react-codemirror": "static-1.10896",
  "react-colorpicker": "static-2.10464",
  "reference-resolvers-lite": "static-1.8357",
  "rich-text-lib": "static-1.20245",
  "tinymce-data": "static-1.41108",
  "tinymce-themes": "static-1.56993",
  "ui-addon-emoji-picker": "static-1.10142",
  "ui-addon-sales-email": "static-1.5472",
  "ui-brand-identity-lib": "static-1.16266",
  "bender-build-tools": "static-1.3382",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10543",
  "hubspotter-http-shared-msw-handlers": "static-1.10541",
  "usage-tracker-session-replay": "static-1.5299",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1223",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.329",
  "chirp-fetch": "static-1.2150",
  "chatspot-core": "static-1.22701",
  "copilot-toolkit": "static-1.11766",
  "customer-data-objects-ui-components": "static-1.13286",
  "data-fetching-client": "static-1.9914",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5012",
  "ui-addon-video-player": "static-1.8960",
  "ui-coaching-tips": "static-1.29234",
  "usage-tracker": "static-1.7613",
  "cms-field-types": "static-1.5071",
  "content-icons-ui": "static-1.2321",
  "integrations-lib": "static-1.16948",
  "customer-data-objects": "static-1.7944",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1597",
  "apollo-link-hub-http": "static-2.4912",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4408",
  "ui-addon-iframeable": "static-1.9331",
  "video-components-external": "static-1.12079",
  "video-data-lib": "static-1.35737",
  "breeze-artifacts-sdk": "static-1.218",
  "audio-components": "static-1.6284",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29747",
  "FileManagerImages": "static-1.37540",
  "foundations-components-legacy": "static-1.1435",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.531",
  "ui-universal-auth": "static-1.9313",
  "urlinator": "static-1.4789",
  "video-components": "static-1.14081",
  "video-embed": "static-1.36571",
  "ts-schema": "static-1.4263",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10202",
  "react-dnd-compat": "static-1.4872",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1797",
  "external-options-client-types": "static-1.4309",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7149",
  "hs-promise-utils": "static-1.5852",
  "inbound-db-properties-service-client": "static-1.4026",
  "NamespacedHubStyle": "static-2.9231",
  "growth-onboarding-confetti": "static-1.3319",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11400",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5724",
  "magpie-types": "static-1.5184",
  "simple-logging-lib": "static-1.3307",
  "avatar-components": "static-1.2751",
  "customer-data-ui-utilities": "static-1.10084",
  "growth-onboarding-feedback-components": "static-1.6841",
  "flux-actions": "static-1.361",
  "hubspot-apollo-client": "static-1.5135",
  "integrations-error-boundary-lib": "static-1.14363",
  "integrations-tracking-lib": "static-1.5865",
  "laboratory-lib": "static-3.7409",
  "native-integrations-shared-strings": "static-1.8034",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10521",
  "unified-auth": "static-1.827",
  "breeze-engine-chat-components": "static-1.575",
  "breeze-engine-core": "static-1.875",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8058",
  "content-media-composition-data-lib": "static-1.13140",
  "content-media-compositions": "static-2.17147",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19347",
  "unified-auth-core-lib": "static-1.1109",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15519",
  "advanced-menus-lib": "static-1.12398",
  "ExportDialog": "static-6.10635",
  "ui-memberships-settings-lib": "static-1.34761",
  "conditional-properties-service-client": "static-1.3983",
  "crm-pipelines-api-client-types": "static-1.4317",
  "fdsr-migration-layer": "static-1.268",
  "framework-builder-read-service-client": "static-1.4190",
  "framework-data-schema-quick-fetch": "static-1.7054",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3878",
  "persist-promise": "static-1.3954",
  "foundations-components-test-utils": "static-1.5893",
  "reactive-lib": "static-1.978",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.594",
  "universal-page-editor-lib": "static-1.3264",
  "adobe-sign-auth-lib": "static-1.374",
  "ads-unified-auth-lib": "static-1.1123",
  "google-sheets-integration-lib": "static-1.950",
  "microsoft-drive-auth-lib": "static-1.45",
  "surveymonkey-integration-lib": "static-1.394",
  "slack-ui-library": "static-1.10655",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3997",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15518",
  "simple-menus-lib": "static-1.17035",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10011",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30724",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55239",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8283",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11740",
  "I18n": "/I18n/static-7.1664",
  "quartz": "/quartz/static-1.7391",
  "quartz-config": "/quartz-config/static-1.1169",
  "quartz-core": "/quartz-core/static-1.6610",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.874",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55226",
  "feedback-utils": "/feedback-utils/static-1.55230",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4721",
  "forms-utils-lib": "/forms-utils-lib/static-1.13033",
  "foundations-assets": "/foundations-assets/static-1.5140",
  "foundations-components": "/foundations-components/static-1.8410",
  "foundations-theming": "/foundations-theming/static-1.4722",
  "hub-http": "/hub-http/static-1.6470",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12047",
  "icons": "/icons/static-2.675",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4101",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16968",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5524",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "tinymce-plugins": "/tinymce-plugins/static-1.58137",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1232",
  "UIComponents": "/UIComponents/static-3.8686",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3587",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3668",
  "quartz-webpack": "/quartz-webpack/static-1.3615",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2438",
  "property-description-translator": "/property-description-translator/static-1.4097",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3394",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4573",
  "jasmine-runner": "/jasmine-runner/static-1.6706",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.27",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4832",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.402",
  "quartz-auth": "/quartz-auth/static-1.1066",
  "quartz-head": "/quartz-head/static-1.1056",
  "quartz-i18n": "/quartz-i18n/static-1.1066",
  "quartz-routing": "/quartz-routing/static-1.821",
  "quartz-test": "/quartz-test/static-1.1066",
  "quartz-tracking": "/quartz-tracking/static-1.770",
  "trellis-components": "/trellis-components/static-1.2528",
  "ui-fonts": "/ui-fonts/static-1.1002",
  "usage-tracker-container": "/usage-tracker-container/static-1.7603",
  "usage-tracker-core": "/usage-tracker-core/static-1.7463",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.162",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7505",
  "reference-resolvers": "/reference-resolvers/static-1.8436",
  "sanitize-text": "/sanitize-text/static-1.8407",
  "PatternValidationJS": "/PatternValidationJS/static-1.3154",
  "ReduxMessenger": "/ReduxMessenger/static-2.10624",
  "sanitize": "/sanitize/static-1.4732",
  "outpost": "/outpost/static-1.4417",
  "rpc-client-utils": "/rpc-client-utils/static-1.4919",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4679",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9683",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2509",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3205",
  "foundations-theming-base": "/foundations-theming-base/static-1.3707",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.262",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9620",
  "atom": "/atom/static-1.5342",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8142",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "data-token-picker": "/data-token-picker/static-1.16827",
  "file-manager-components": "/file-manager-components/static-1.24389",
  "FileManagerCore": "/FileManagerCore/static-1.39888",
  "FileManagerLib": "/FileManagerLib/static-1.40029",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8183",
  "hub-http-contrib": "/hub-http-contrib/static-1.3294",
  "interframe": "/interframe/static-3.5012",
  "layout-dnd-components": "/layout-dnd-components/static-1.12902",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11877",
  "property-translator": "/property-translator/static-1.5654",
  "react-codemirror": "/react-codemirror/static-1.10896",
  "react-colorpicker": "/react-colorpicker/static-2.10464",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8357",
  "rich-text-lib": "/rich-text-lib/static-1.20245",
  "tinymce-data": "/tinymce-data/static-1.41108",
  "tinymce-themes": "/tinymce-themes/static-1.56993",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10142",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5472",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16266",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10543",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10541",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5299",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1223",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.329",
  "chirp-fetch": "/chirp-fetch/static-1.2150",
  "chatspot-core": "/chatspot-core/static-1.22701",
  "copilot-toolkit": "/copilot-toolkit/static-1.11766",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13286",
  "data-fetching-client": "/data-fetching-client/static-1.9914",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5012",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8960",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29234",
  "usage-tracker": "/usage-tracker/static-1.7613",
  "cms-field-types": "/cms-field-types/static-1.5071",
  "content-icons-ui": "/content-icons-ui/static-1.2321",
  "integrations-lib": "/integrations-lib/static-1.16948",
  "customer-data-objects": "/customer-data-objects/static-1.7944",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1597",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4912",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4408",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9331",
  "video-components-external": "/video-components-external/static-1.12079",
  "video-data-lib": "/video-data-lib/static-1.35737",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.218",
  "audio-components": "/audio-components/static-1.6284",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29747",
  "FileManagerImages": "/FileManagerImages/static-1.37540",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1435",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.531",
  "ui-universal-auth": "/ui-universal-auth/static-1.9313",
  "urlinator": "/urlinator/static-1.4789",
  "video-components": "/video-components/static-1.14081",
  "video-embed": "/video-embed/static-1.36571",
  "ts-schema": "/ts-schema/static-1.4263",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10202",
  "react-dnd-compat": "/react-dnd-compat/static-1.4872",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1797",
  "external-options-client-types": "/external-options-client-types/static-1.4309",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7149",
  "hs-promise-utils": "/hs-promise-utils/static-1.5852",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4026",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9231",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3319",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11400",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5724",
  "magpie-types": "/magpie-types/static-1.5184",
  "simple-logging-lib": "/simple-logging-lib/static-1.3307",
  "avatar-components": "/avatar-components/static-1.2751",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10084",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6841",
  "flux-actions": "/flux-actions/static-1.361",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5135",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14363",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5865",
  "laboratory-lib": "/laboratory-lib/static-3.7409",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8034",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10521",
  "unified-auth": "/unified-auth/static-1.827",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.575",
  "breeze-engine-core": "/breeze-engine-core/static-1.875",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8058",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13140",
  "content-media-compositions": "/content-media-compositions/static-2.17147",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19347",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1109",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15519",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12398",
  "ExportDialog": "/ExportDialog/static-6.10635",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34761",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3983",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4317",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.268",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4190",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7054",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3878",
  "persist-promise": "/persist-promise/static-1.3954",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5893",
  "reactive-lib": "/reactive-lib/static-1.978",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.594",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3264",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.374",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1123",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.950",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.45",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.394",
  "slack-ui-library": "/slack-ui-library/static-1.10655",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3997",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15518",
  "simple-menus-lib": "/simple-menus-lib/static-1.17035",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10011",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
